import type { WorkbookDetail } from '@mathflat/domain/Workbook'
import { computed, makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'

export class PrintPageInfo extends DTO {
  initPage = 1 // 문제의 첫 페이지 - 교재는 표지때문에 1이 아님
  elementPage = 1 // 문제 페이지 마지막
  quickAnswerPage = 0 //빠른 정답 페이지 마지막
  answerSolutionPage = 0 // 정답과 해설 페이지 마지막
  omrPage = 0 // omr 페이지 마지막
  targetId = -1 // 학습지 또는 교재 아이디

  // 내지 페이지
  coverPages: WorkbookDetail['coverPages'] = {
    mainCoverPages: [],
    chapterCoverPages: [],
  }

  constructor(data?: Partial<PrintPageInfo>) {
    super()

    if (data) {
      this.initPage = data.initPage || 1
      this.elementPage = data.elementPage || 1
      this.quickAnswerPage = data.quickAnswerPage || 0
      this.answerSolutionPage = data.answerSolutionPage || 0
      this.omrPage = data.omrPage || 0
      this.targetId = data.targetId || -1
    }

    if (data?.coverPages) {
      this.coverPages = data.coverPages
    }

    makeObservable(this, {
      initPage: observable,
      elementPage: observable,
      quickAnswerPage: observable,
      answerSolutionPage: observable,
      omrPage: observable,
      targetId: observable,
      coverPages: observable,
      maxPage: computed,
      minPage: computed,
    })
  }

  get maxPage() {
    return Math.max(
      this.initPage,
      this.elementPage,
      this.quickAnswerPage,
      this.answerSolutionPage,
      this.omrPage,
    )
  }

  get minPage() {
    return Math.min.apply(
      null,
      [
        this.initPage,
        this.elementPage,
        this.quickAnswerPage,
        this.answerSolutionPage,
        this.omrPage,
      ].filter(Boolean),
    )
  }
}
